
import {
  Component, Prop, ProvideReactive, Vue,
} from 'nuxt-property-decorator'
import { FSXARichText } from 'fsxa-pattern-library'

@Component({
  name: 'WhiteRichText',
  components: { FSXARichText },
})
export default class WhiteRichText extends Vue {
  @ProvideReactive('linkColor') linkColor : 'white' = 'white'

  @Prop({ required: true }) description! : string
}
